import { createFeatureSelector, type MemoizedSelector } from '@ngrx/store';
import type { AppState } from '../app.state';
import type { State } from './pages.state';

export const selectPagesState: MemoizedSelector<AppState, State> = createFeatureSelector('pages');
